import { Text, Stack, VStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { Box } from 'native-base';
import React from 'react';

import { TableContentItemBadge } from '../../../../../../components/TableContent';

interface CustomerDetailsProps {}

export const CustomerDetails: React.FC<CustomerDetailsProps> = () => {
  const isTablet = useBreakpointValue({ base: false, sm: true, lg: false });
  const isMobile = useBreakpointValue({ base: true, sm: false });

  return (
    <VStack space={Spacing['inline.xxxs']}>
      <Text fontSize={Typography['fontsize.lg']} variant="semibold">
        Detalhes do cliente
      </Text>
      <Box bg="neutral.lightest" h="0.5px" />
      <Stack
        direction={{ base: 'column', sm: 'row' }}
        alignItems="center"
        {...(isMobile && { space: Spacing['stack.nano'] })}
        justifyContent="space-between">
        <Stack
          direction={{ base: 'column', sm: 'row' }}
          alignItems="center"
          space={Spacing['inline.xxxs']}
          {...(isMobile && { w: 'full' })}>
          {isTablet && <TableContentItemBadge>conservador</TableContentItemBadge>}
          <Stack
            direction={{ base: 'row', sm: 'column' }}
            space={Spacing['stack.quarck']}
            {...(isMobile && {
              w: 'full',
              alignItems: 'center',
              justifyContent: 'space-between',
            })}>
            <Text
              fontSize={Typography['fontsize.md']}
              color={{ base: 'neutral.dark', sm: 'neutral.black' }}
              variant={{ base: 'regular', sm: 'semibold' }}>
              Nome
            </Text>
            <Text fontSize={Typography['fontsize.md']} color="neutral.darkest">
              Nome completo do cliente
            </Text>
          </Stack>
        </Stack>
        <Stack
          direction={{ base: 'row', sm: 'column' }}
          space={Spacing['stack.quarck']}
          {...(isMobile && {
            w: 'full',
            alignItems: 'center',
            justifyContent: 'space-between',
          })}>
          <Text
            fontSize={Typography['fontsize.md']}
            color={{ base: 'neutral.dark', sm: 'neutral.black' }}
            variant={{ base: 'regular', sm: 'semibold' }}>
            CPF/CNPJ
          </Text>
          <Text fontSize={Typography['fontsize.md']} color="neutral.darkest">
            000.000.000-00
          </Text>
        </Stack>
        {!isTablet && (
          <Stack
            direction={{ base: 'row', sm: 'column' }}
            space={Spacing['stack.quarck']}
            {...(isMobile && {
              w: 'full',
              alignItems: 'center',
              justifyContent: 'space-between',
            })}>
            <Text
              fontSize={Typography['fontsize.md']}
              color={{ base: 'neutral.dark', sm: 'neutral.black' }}
              variant={{ base: 'regular', sm: 'semibold' }}>
              Conta
            </Text>
            <Text fontSize={Typography['fontsize.md']} color="neutral.darkest">
              00000-0
            </Text>
          </Stack>
        )}
        {!isTablet && (
          <Stack
            direction={{ base: 'row', sm: 'column' }}
            space={Spacing['stack.quarck']}
            {...(isMobile && {
              w: 'full',
              alignItems: 'center',
              justifyContent: 'space-between',
            })}>
            <Text
              fontSize={Typography['fontsize.md']}
              color={{ base: 'neutral.dark', sm: 'neutral.black' }}
              variant={{ base: 'regular', sm: 'semibold' }}>
              Suitability
            </Text>
            {isMobile ? (
              <Text
                textTransform="uppercase"
                fontSize={Typography['fontsize.md']}
                color="neutral.darkest">
                conservador
              </Text>
            ) : (
              <TableContentItemBadge>conservador</TableContentItemBadge>
            )}
          </Stack>
        )}
        <Stack
          direction={{ base: 'row', sm: 'column' }}
          space={Spacing['stack.quarck']}
          {...(isMobile && {
            w: 'full',
            alignItems: 'center',
            justifyContent: 'space-between',
          })}>
          <Text
            fontSize={Typography['fontsize.md']}
            color={{ base: 'neutral.dark', sm: 'neutral.black' }}
            variant={{ base: 'regular', sm: 'semibold' }}>
            {isTablet ? 'Cadastro' : 'Situação cadastral'}
          </Text>
          <Text fontSize={Typography['fontsize.md']} color="neutral.darkest">
            Ativo
          </Text>
        </Stack>
        <Stack
          direction={{ base: 'row', sm: 'column' }}
          {...(isMobile && {
            w: 'full',
            alignItems: 'center',
            justifyContent: 'space-between',
          })}
          space={Spacing['stack.quarck']}
          {...(!isMobile && { alignItems: 'flex-end' })}>
          <Text
            fontSize={Typography['fontsize.md']}
            color={{ base: 'neutral.dark', sm: 'neutral.black' }}
            variant={{ base: 'regular', sm: 'semibold' }}>
            Saldo disponível
          </Text>
          <Text fontSize={Typography['fontsize.md']} color="neutral.darkest">
            R$ 258.000,00
          </Text>
        </Stack>
      </Stack>
    </VStack>
  );
};
